import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import PageTitle from "../ui/PageTitle";
import ToastMsg from "../ui/ToastMsg";
import useApp from "../../utils/useApp";
import { trackNavigationEvent } from "../../utils/analytics";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBed, faBriefcase, faBullseye, faClipboardQuestion, faFileText, faUserFriends } from "@fortawesome/free-solid-svg-icons";
import OrgGoalTemplates from "./goaltemplates/OrgGoalTemplates";
import OrgDetails from "./details/OrgDetails";
import useMenuToggle from "../../utils/useMenuToggle";
import OrgHousehold from "./householdconfig/OrgHousehold";
import OrgCustomAssessments from "./assessments/OrgCustomAssessments";
import OrgBedManagement from "./beds/OrgBedManagement";
import OrgCustomNoteTypes from "./notes/OrgCustomNoteTypes";

const Settings = () => {
  const { showMenu, auth }: any = useApp();
  const toggleMenu = useMenuToggle();
  const [activeDetails, setActiveDetails] = useState<boolean>(false);
  const [activeHousehold, setActiveHousehold] = useState<boolean>(false);
  const [activeNotes, setActiveNotes] = useState<boolean>(false);
  const [activeGoals, setActiveGoals] = useState<boolean>(false);
  const [activeAssessTypes, setActiveAssessTypes] = useState<boolean>(false);
  const [activeBedManage, setActiveBedManage] = useState<boolean>(false);
  const [orgToSave, setOrgToSave] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastBody, setToastBody] = useState<string>("");
  const [toastText, setToastText] = useState<string>("");
  const searchRef = useRef<HTMLInputElement>(null);
  //get active tab data states
  const [getHouseholdData, setGetHouseholdData] = useState<boolean>(false);
  const [getNoteTypeData, setGetNoteTypeData] = useState<boolean>(false);
  const [getTemplateData, setGetTemplateData] = useState<boolean>(false);
  const [getAssessTypeData, setGetAssessTypeData] = useState<boolean>(false);
  const [getBedManagementData, setGetBedManagementData] = useState<boolean>(false);

  useEffect(() => {
    setActiveDetails(true);
    setActiveHousehold(false);
    setActiveNotes(false);
    setActiveGoals(false);
    setActiveAssessTypes(false);
    setActiveBedManage(false);

    trackNavigationEvent("switch_view", "org_details");
  }, []);

  const onNavClick = (route: string) => {
    if (route) {
      trackNavigationEvent("switch_view", "org_" + route);
    }

    switch (route) {
      case "details":
        setActiveDetails(true);
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveGoals(false);
        setActiveAssessTypes(false);
        setActiveBedManage(false);

        setGetHouseholdData(false);
        setGetNoteTypeData(false);
        setGetTemplateData(false);
        setGetAssessTypeData(false);
        setGetBedManagementData(false);
        break;
      case "household":
        setActiveDetails(false);
        setActiveHousehold(true);
        setActiveNotes(false);
        setActiveGoals(false);
        setActiveAssessTypes(false);
        setActiveBedManage(false);

        setGetHouseholdData(true);
        setGetNoteTypeData(false);
        setGetTemplateData(false);
        setGetAssessTypeData(false);
        setGetBedManagementData(false);
        break;
      case "notes":
        setActiveDetails(false);
        setActiveHousehold(false);
        setActiveNotes(true);
        setActiveGoals(false);
        setActiveAssessTypes(false);
        setActiveBedManage(false);

        setGetHouseholdData(false);
        setGetNoteTypeData(true);
        setGetTemplateData(false);
        setGetAssessTypeData(false);
        setGetBedManagementData(false);
        break;
      case "goals":
        setActiveDetails(false);
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveGoals(true);
        setActiveAssessTypes(false);
        setActiveBedManage(false);

        setGetHouseholdData(false);
        setGetNoteTypeData(false);
        setGetTemplateData(true);
        setGetAssessTypeData(false);
        setGetBedManagementData(false);
        break;
      case "assessments":
        setActiveDetails(false);
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveGoals(false);
        setActiveAssessTypes(true);
        setActiveBedManage(false);

        setGetHouseholdData(false);
        setGetNoteTypeData(false);
        setGetTemplateData(false);
        setGetAssessTypeData(true);
        setGetBedManagementData(false);
        break;
      case "bed_management":
        setActiveDetails(false);
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveGoals(false);
        setActiveAssessTypes(false);
        setActiveBedManage(true);

        setGetHouseholdData(false);
        setGetNoteTypeData(false);
        setGetTemplateData(false);
        setGetAssessTypeData(false);
        setGetBedManagementData(true);
        break;
      default:
        setActiveDetails(true);
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveGoals(false);
        setActiveAssessTypes(false);
        setActiveBedManage(false);

        setGetHouseholdData(false);
        setGetNoteTypeData(false);
        setGetTemplateData(false);
        setGetAssessTypeData(false);
        setGetBedManagementData(false);
        break;
    }
  };

  return (
    <>
      <ToastMsg showToast={showToast} setShowToast={setShowToast} toastText={toastText} toastBody={toastBody} />

      <Container className={showMenu ? "lg div-main-menu custom-container" : "lg div-main custom-container"}>
        <Tab.Container defaultActiveKey={"details"}>
          <Row>
            <Col sm={toggleMenu ? 3 : 1}>
              <Nav
                variant="pills"
                className={showMenu ? "flex-column sticky-top mycase-menu-open-sticky" : "flex-column sticky-top mycase-menu-sticky"}
              >
                <Nav.Item className="mb-2">
                  {toggleMenu ? (
                    <PageTitle title={"Organization"} type={"page"} />
                  ) : (
                    <span className="hero-heading font-size-dynamic-heading fw-semibold app-header-text">{"Org"}</span>
                  )}
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="details"
                    className={activeDetails ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("details")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faBriefcase} className={toggleMenu ? "me-2" : "me-0"} />
                      {toggleMenu ? "Details" : ""}
                    </>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="household"
                    className={activeHousehold ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("household")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faUserFriends} className={toggleMenu ? "me-2" : "me-0"} />
                      {toggleMenu ? "Household Config" : ""}
                    </>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="notes"
                    className={activeNotes ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("notes")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faFileText} className={toggleMenu ? "me-2" : "me-0"} />
                      {toggleMenu ? "Custom Notes" : ""}
                    </>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="goals"
                    className={activeGoals ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("goals")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faBullseye} className={toggleMenu ? "me-2" : "me-0"} />
                      {toggleMenu ? "Goal Templates" : ""}
                    </>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="assessments"
                    className={activeAssessTypes ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("assessments")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faClipboardQuestion} className={toggleMenu ? "me-2" : "me-0"} />
                      {toggleMenu ? "Custom Assessments" : ""}
                    </>
                  </Nav.Link>
                </Nav.Item>
                {auth?.profile?.includeHMIS === 1 && (
                  <Nav.Item className="d-grid">
                    <Nav.Link
                      eventKey="bed_management"
                      className={activeBedManage ? "nav-vertical-active" : "nav-vertical"}
                      onClick={() => onNavClick("bed_management")}
                      disabled={orgToSave === true ? true : false}
                    >
                      <>
                        <FontAwesomeIcon icon={faBed} className={toggleMenu ? "me-2" : "me-0"} />
                        {toggleMenu ? "Bed Management" : ""}
                      </>
                    </Nav.Link>
                  </Nav.Item>
                )}
              </Nav>
            </Col>
            <Col xs={toggleMenu ? 9 : 11} className="mt-2">
              <Tab.Content>
                <Tab.Pane eventKey="details" className="pb-5">
                  <OrgDetails
                    setOrgToSave={setOrgToSave}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="household" className="pb-5">
                  <OrgHousehold
                    setOrgToSave={setOrgToSave}
                    getData={getHouseholdData}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="notes" className="pb-5">
                  <OrgCustomNoteTypes
                    setOrgToSave={setOrgToSave}
                    getData={getNoteTypeData}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="goals" className="pb-5">
                  <OrgGoalTemplates
                    searchRef={searchRef}
                    setOrgToSave={setOrgToSave}
                    getData={getTemplateData}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="assessments" className="pb-5">
                  <OrgCustomAssessments
                    setOrgToSave={setOrgToSave}
                    getData={getAssessTypeData}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Tab.Pane>
                {auth?.profile?.includeHMIS === 1 && (
                  <Tab.Pane eventKey="bed_management">
                    <OrgBedManagement
                      setOrgToSave={setOrgToSave}
                      setShowToast={setShowToast}
                      setToastText={setToastText}
                      setToastBody={setToastBody}
                      getData={getBedManagementData}
                    />
                  </Tab.Pane>
                )}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </>
  );
};

export default Settings;
